import "./styles/App.css";
import moment from "moment";
import "moment/locale/vi";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import MainLayout from "./Layout";
import TrangChu from "./routes/trangquantri/trangchu";
import RoutesNhatKyHeThong from "./routes/NhatKyHeThong";
import RoutesQuanLyNguoiDung from "./routes/QuanTriHeThong/QuanLyNguoiDung";
import DanhMuc from "./routes/DanhMuc/index";
import { DanhMucList } from "./routes/DanhMuc/configMenu";
import RoutesCoSoPhanPhoi from "./routes/ThongTinSanXuat/CoSoPhanPhoi";
import RoutesCoSoSanXuat from "./routes/ThongTinSanXuat/CoSoSanXuat";
import RoutesDuLieuThongKe from "./routes/BaoCaoThongKe/DuLieuThongKe";
import RoutesDuLieuKhiHau from "./routes/BaoCaoThongKe/DuLieuKhiHau";
import RoutesBaoCaoChuyenDe from "./routes/BaoCaoThongKe/BaoCaoChuyenDe";
import RoutesCoSoCheBien from "./routes/ThongTinSanXuat/CoSoCheBien";
import RoutesSanPham from "./routes/SanPham";
import RoutesThongTinDoanhNghiep, { ThongTinDoanhNghiepTKDN } from "./routes/DoanhNghiep";
import RoutesVungSanXuat from "./routes/VungSanXuat";
import RoutesLoHang from "./routes/LoHang";
import RoutesLichSuSanXuat from "./routes/LichSuSanXuat";
import RoutesCauHinhHienThiSanPham from "./routes/QuanTriHeThong/CauHinhHienThiSanPham";
import RoutesQuanLySilde from "./routes/QuanTriHeThong/QuanLySilde";
import RoutesQuanLyTinTuc from "./routes/QuanTriHeThong/QuanLyTinTuc";
import BanDo from "./routes/BanDo/index.js";
import Login from "./routes/Auth/Login.js";
import { useSelector } from "react-redux";
import { commonReducerSelector, userSelector } from "./redux/selector";
import PageNotFound from "./routes/Auth/PageNotFound.js";
import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import userReducer from "./redux/slice/userSlice.js";
import { Box, CircularProgress } from "@mui/material";
import RoutesQuanLyNhomNguoiDung from "./routes/QuanTriHeThong/QuanLyNhomNguoiDung/index.js";
import RoutesPhanQuyenChucNang from "./routes/QuanTriHeThong/PhanQuyenChucNang/index.js";
import RoutesQuanLyNhomChucNang from "./routes/QuanTriHeThong/QuanLyNhomChucNang/index.js";
import RoutesQuanLyChucNang from "./routes/QuanTriHeThong/QuanLyChucNang/index.js";
import Helper from "./helpers.js";
import { maChucNang } from "./constants/constant.js";
import { getFunctionsByRole, getProfile } from "./services/apis/danhmuc-service.js";
import { isEmpty } from "lodash";
import { setCurrentUser } from "./api2.js";
import { setCurrentUser2 } from "./api_danhmuc.js";

moment.locale("vi");

// Đọc hạn dùng ngay trong token thay vì chờ server trả 401. Token hỏng hoặc
// hết hạn thì coi như chưa đăng nhập, tránh vào trạng thái treo màn hình chờ.
function tokenConHan(token) {
  try {
    var payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload || !payload.exp) return true;
    return payload.exp * 1000 > Date.now();
  } catch (e) {
    return false;
  }
}

function App() {
  const dispatch = useDispatch()
  const user = useSelector(userSelector)
  const [loading, setLoading] = useState(true);
  const common = useSelector(commonReducerSelector);

  const userPermissionObj = Helper.handleGroupFunctions(common?.functions?.data) || [];
  const userPermissions = Object.values(userPermissionObj).flat();
  const routesWithPermissions = [
    { path: "trangchu", element: <TrangChu />, maChucNang: maChucNang.TC },
    { path: "bando", element: <BanDo />, maChucNang: maChucNang.BANDO },
    { path: "danhmuc", element: <DanhMuc />, maChucNang: maChucNang.DANHMUC },
    { path: "danhmuc/:id", element: <DanhMuc />, maChucNang: maChucNang.DANHMUC },
    { path: "doanhnghiep/infor/:id", element: <ThongTinDoanhNghiepTKDN />, maChucNang: maChucNang.THONGTINDOANHNGHIEP },
    { path: "nhat-ky-he-thong", element: <Outlet />, maChucNang: maChucNang.NHATKYHETHONG, children: RoutesNhatKyHeThong },
    { path: "quantrihethong/quanlynguoidung", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYNGUOIDUNG, children: RoutesQuanLyNguoiDung },
    { path: "quantrihethong/quanlyslide", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYSLIDE, children: RoutesQuanLySilde },
    { path: "quantrihethong/quanlytintuc", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYTINTUC, children: RoutesQuanLyTinTuc },
    { path: "quantrihethong/cauhinhhienthithongtintruyxuat", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_CAUHINHHIENTHISANPHAM, children: RoutesCauHinhHienThiSanPham },
    { path: "quantrihethong/quanlynhomnguoidung", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYNHOMNGUOIDUNG, children: RoutesQuanLyNhomNguoiDung },
    { path: "quantrihethong/phanquyenchucnang", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_PHANQUYENCHUCNANG, children: RoutesPhanQuyenChucNang },
    { path: "quantrihethong/quanlynhomchucnang", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYNHOMCHUCNANG, children: RoutesQuanLyNhomChucNang },
    { path: "quantrihethong/quanlychucnang", element: <Outlet />, maChucNang: maChucNang.QUANTRIHETHONG_QUANLYCHUCNANG, children: RoutesQuanLyChucNang },
    { path: "thongtinsanxuat/cososanxuat", element: <Outlet />, maChucNang: maChucNang.THONGTINSANXUAT_COSOSANXUAT, children: RoutesCoSoSanXuat },
    { path: "thongtinsanxuat/cosophanphoi", element: <Outlet />, maChucNang: maChucNang.THONGTINSANXUAT_COSOPHANPHOI, children: RoutesCoSoPhanPhoi },
    { path: "thongtinsanxuat/cosochebien", element: <Outlet />, maChucNang: maChucNang.THONGTINSANXUAT_COSOCHEBIEN, children: RoutesCoSoCheBien },
    { path: "baocaothongke/dulieuthongke", element: <Outlet />, maChucNang: maChucNang.BAOCAOTHONGKE_DULIEUTHONGKE, children: RoutesDuLieuThongKe },
    { path: "baocaothongke/dulieukhihau", element: <Outlet />, maChucNang: maChucNang.BAOCAOTHONGKE_DULIEUKHIHAU, children: RoutesDuLieuKhiHau },
    { path: "baocaothongke/baocaochuyende", element: <Outlet />, maChucNang: maChucNang.BAOCAOTHONGKE_BAOCAOCHUYENDE, children: RoutesBaoCaoChuyenDe },
    { path: "sanpham", element: <Outlet />, maChucNang: maChucNang.SANPHAM, children: RoutesSanPham },
    { path: "thongtindoanhnghiep", element: <Outlet />, maChucNang: maChucNang.THONGTINDOANHNGHIEP, children: RoutesThongTinDoanhNghiep },
    { path: "vungsanxuat", element: <Outlet />, maChucNang: maChucNang.VUNGTRONG, children: RoutesVungSanXuat },
    { path: "lohang", element: <Outlet />, maChucNang: maChucNang.LOHANG, children: RoutesLoHang },
    { path: "lichsusanxuat", element: <Outlet />, maChucNang: maChucNang.LICHSUSANXUAT, children: RoutesLichSuSanXuat },
  ];
  const allowedRoutes = routesWithPermissions.filter(route =>
    userPermissions.includes(route.maChucNang)
  )

  useEffect(() => {
    const token = localStorage.getItem('accessToken')
    // token cu con trong localStorage nhung da het han: phai don ngay, neu khong
    // App se coi nhu da dang nhap roi ket o man hinh cho vinh vien
    if (token && !tokenConHan(token)) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('hasLoggedIn');
      dispatch(userReducer.actions.clearUserInfo());
      setLoading(false)
      return;
    }
    if (!user?.access_token) {
      setLoading(true)
      if (token) {
        dispatch(userReducer.actions.setUserInfo({ token: token }));
      }
    }
    if (!user?.isLoggedIn && !token) {
      setLoading(false)
    }
  }, [])
  useEffect(() => {
      if (!isEmpty(user?.access_token)) {
        setCurrentUser(user);
        setCurrentUser2(user);
        dispatch(getProfile(user));
        dispatch(getFunctionsByRole(user));
      }
    }, [user]);
  useEffect(() => {
    if (!isEmpty(userPermissions)) {
      setLoading(false)
      return;
    }
    // Truoc day chi tat loading khi CO quyen, nen khi getProfile/getFunctionsByRole
    // that bai (token het han -> 401) thi man hinh xoay mai khong dung.
    const profileXong =
      common?.profile?.loading === 'success' || common?.profile?.loading === 'error';
    const functionsXong =
      common?.functions?.loading === 'success' || common?.functions?.loading === 'error';
    if (!profileXong || !functionsXong) return;

    // goi profile khong ra du lieu = token khong dung duoc nua
    if (isEmpty(common?.profile?.data)) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('hasLoggedIn');
      dispatch(userReducer.actions.clearUserInfo());
    }
    setLoading(false)
  }, [common])
    
  if (loading) {
    return (
      <div className="flat">
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }
  return (
    <BrowserRouter basename="" innerRef={node => (window.globalRouter = node)}>
      <Routes>
        {!user.isLoggedIn && <Route index element={<Login />} />}
        {user.isLoggedIn &&
          <Route element={<MainLayout setLoading={setLoading} />}>
            <Route index element={<TrangChu />} />
            {allowedRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element}>
                {route.children?.map((child, childIndex) => (
                  <Route key={childIndex} path={child.path} element={<child.main />} />
                ))}
              </Route>
            ))}
            {
              userPermissions.includes(maChucNang.DANHMUC) &&
              <Route path="danhmuc" element={<Outlet />}>
                {DanhMucList.map((item, index) => (
                  <Route path={item.path} key={index} element={<Outlet />}>
                    {item.childRoute?.map((route, childIndex) => (
                      <Route path={route.path} key={childIndex} element={<route.main />} />
                    ))}
                  </Route>
                ))}
              </Route>
            }
          </Route>
        }
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
